import { useTableState } from '@driftt/dds'
import { pathOr } from 'ramda'
import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { getBlocksTableData } from 'api/blocks'

export const useAllOrgBlocks = ({
  nameQuery = '',
  sortProperty = 'updated_at',
  sortDirection = 'desc',
  status = 'ENABLED',
  page = 0,
  pageSize = 25,
}) => {
  const { tableState, handleTableStateChange } = useTableState({
    defaultPagination: {
      pageIndex: page,
      pageSize: pageSize,
    },
  })
  const {
    isLoading,
    data: blockListData,
    refetch: refetchTableState,
  } = useQuery({
    queryKey: [
      `playbook-block-list--all-${tableState.pagination.pageIndex}-${tableState.pagination.pageSize}`,
      nameQuery,
      status,
    ],
    queryFn: () =>
      getBlocksTableData({
        nameQuery,
        sortDirection,
        sortProperty,
        status,
        page: tableState.pagination.pageIndex,
        pageSize: tableState.pagination.pageSize,
      }),
    select: ({ data }) => {
      return data
    },
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    staleTime: Infinity,
    retry: false,
  })

  const memoizedBlocks = useMemo(
    () => pathOr([], ['blockPageRows'], blockListData),
    [blockListData]
  )

  const memoizedRowTotal = useMemo(
    () => pathOr(0, ['meta', 'total'], blockListData),
    [blockListData]
  )

  return {
    isLoading,
    blocks: memoizedBlocks,
    handleTableStateChange,
    pagination: tableState.pagination,
    rowTotal: memoizedRowTotal,
    refetchTableState,
  }
}
